'use client';

import { ISalePageDetailResponse } from '@/api/types';
import { Button } from '@/components';
import { HTML } from '@/components/html';
import { qaAttr, qaId } from '@/lib/qa';
import { Element } from '@vuddy/components';
import { useState } from 'react';
import * as styles from './description.css';
import { useFoldDescription } from './useFoldDescription';

interface SalePageDescriptionProps {
  salePage?: Partial<ISalePageDetailResponse>;
}

export const SalePageDescription = ({ salePage }: SalePageDescriptionProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const { isCalculating, isOverflown, htmlRefCallback } = useFoldDescription({
    description: salePage?.description ?? '',
  });

  return (
    <Element
      {...qaAttr(qaId('sale', 'description'))}
      id="goods-description"
      className={styles.scrollTarget}
      paddingTop="padding_small"
      paddingX="padding_small"
      paddingBottom="gap_7xl">
      <div
        className={styles.wrapper({
          isExpanded,
          isOverflown,
          isCalculating,
        })}>
        <div className={styles.description} ref={htmlRefCallback}>
          <HTML html={salePage?.description ?? ''} />
        </div>
        {isOverflown && <div className={styles.fadeOut({ isExpanded })} />}
      </div>
      {(isOverflown || isExpanded) && (
        <Element paddingX="padding_large">
          <Button
            {...qaAttr(qaId('sale', 'description.more'))}
            variant="outlineSecondary"
            onClick={() => setIsExpanded(isExpanded => !isExpanded)}
            fullWidth>
            {isExpanded ? '접기' : '더보기'}
          </Button>
        </Element>
      )}
    </Element>
  );
};
